import { Fragment } from 'react/jsx-runtime'

import './NumericInput.scss'

interface NumericInputProps {
  className?: string
  label: string
  value: number
  increase?: number
  isMobile: boolean
  setValue: (value: number) => void
}

function NumericInput({
  className,
  label,
  value,
  increase,
  setValue,
  isMobile,
}: NumericInputProps) {
  const add = () => {
    setValue(value + (increase ?? 1))
  }

  const remove = () => {
    if (value > 0) {
      setValue(value - (increase ?? 1))
    }
  }

  const labelElement = <span className={className}>{label}:</span>
  const inputs = (
    <Fragment>
      <button className="pop-up-form-number-button" onClick={remove}>
        -
      </button>
      <input
        className={`pop-up-form-number-input ${isMobile ? 'pop-up-form-number-input-mobile' : ''}`}
        type="text"
        value={value}
        onChange={e => setValue(Number(e.target.value))}
      />
      <button className="pop-up-form-number-button" onClick={add}>
        +
      </button>
    </Fragment>
  )
  if (isMobile) {
    return (
      <Fragment>
        <div className="pop-up-form-row"> {labelElement}</div>
        <div className="pop-up-form-row"> {inputs}</div>
      </Fragment>
    )
  } else {
    return (
      <div className="pop-up-form-row">
        {labelElement}
        {inputs}
      </div>
    )
  }
}

export default NumericInput
